module.exports = __webpack_public_path__ + "fa-regular-400.woff2?cd6c777f1945164224dee082abaea03a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-regular-400.woff2
// module id = 41
// module chunks = 0